import { useParams, useNavigate } from "react-router-dom";
import { Printer, ArrowLeft, GraduationCap } from "@phosphor-icons/react";
import { useApi, fmtDate } from "../lib/api";
import { Loader } from "../components/kit";
import { SchoolMark } from "../components/Photo";

export default function ReportCard() {
  const { studentId, examId } = useParams();
  const nav = useNavigate();
  const { data, loading, error } = useApi(`/results/${studentId}`);
  const { data: school } = useApi("/school");
  const r = data?.results.find((x) => x.exam_id === examId);
  return (
    <div className="min-h-screen bg-[#05050a] py-10 px-4 print:bg-white print:p-0">
      <div className="no-print mx-auto mb-6 flex max-w-3xl justify-between">
        <button className="btn-ghost" onClick={() => nav(-1)} data-testid="reportcard-back-btn"><ArrowLeft size={16} /> Back</button>
        <button className="btn-primary" onClick={() => window.print()} data-testid="reportcard-print-btn"><Printer size={16} /> Print / Save PDF</button>
      </div>
      {loading ? <Loader /> : error || !r ? <p className="text-center text-rose-300" data-testid="reportcard-error">{error || "Report card not available"}</p> : (
        <div className="mx-auto max-w-3xl rounded-3xl bg-white text-zinc-900 p-8 sm:p-12 shadow-2xl print:shadow-none print:rounded-none" data-testid="reportcard-document">
          <div className="text-center border-b border-zinc-200 pb-6">
            <div className="flex justify-center">
              <SchoolMark school={school} className="h-20 w-20" testid="reportcard-school-logo"
                fallback={<span className="grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-blue-500 to-orange-500 text-white"><GraduationCap size={28} weight="fill" /></span>} />
            </div>
            <div className="mt-3 font-display text-2xl font-bold">{school?.name}</div>
            <div className="text-xs text-zinc-500">{[school?.address, school?.city].filter(Boolean).join(", ")}</div>
            <div className="mt-4 text-[11px] uppercase tracking-[0.3em] text-zinc-500">Report card · {r.exam_name} · {school?.academic_year}</div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 py-6 text-sm">
            {[["Student", data.student.name], ["Admission no", data.student.admission_no], ["Class", data.student.class_name], ["Roll no", data.student.roll_no]].map(([k, v]) => (
              <div key={k}><div className="text-[11px] uppercase tracking-[0.16em] text-zinc-500">{k}</div><div className="font-semibold">{v ?? "—"}</div></div>
            ))}
          </div>
          <table className="w-full text-sm">
            <thead><tr className="border-y border-zinc-200 text-left text-[11px] uppercase tracking-[0.16em] text-zinc-500"><th className="py-2">Subject</th><th className="py-2 text-right">Max</th><th className="py-2 text-right">Obtained</th><th className="py-2 text-right">Grade</th></tr></thead>
            <tbody>
              {r.subjects.map((s) => (
                <tr key={s.name} className="border-b border-zinc-100"><td className="py-2.5">{s.name}</td><td className="py-2.5 text-right">{s.max_marks}</td><td className="py-2.5 text-right font-semibold">{s.marks ?? "—"}</td><td className="py-2.5 text-right">{s.grade}</td></tr>
              ))}
            </tbody>
          </table>
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[["Total", `${r.total}/${r.max_total}`], ["Percentage", r.percent != null ? `${r.percent}%` : "—"], ["Grade", r.grade], ["Rank", r.rank ? `${r.rank} of ${r.class_size}` : "—"]].map(([k, v]) => (
              <div key={k} className="rounded-2xl bg-zinc-100 p-4 text-center"><div className="text-[11px] uppercase tracking-[0.16em] text-zinc-500">{k}</div><div className="mt-1 font-display text-xl font-bold" data-testid={`reportcard-${k.toLowerCase()}`}>{v}</div></div>
            ))}
          </div>
          <div className="mt-6 text-sm font-semibold">{r.passed ? "Result: PASS" : "Result: Needs improvement"}</div>
          <div className="mt-16 grid grid-cols-2 gap-10 text-xs text-zinc-500">
            <div className="border-t border-zinc-300 pt-2 text-center">Class teacher</div>
            <div className="border-t border-zinc-300 pt-2 text-center">Principal · {school?.principal_name}</div>
          </div>
          <div className="mt-6 text-center text-[11px] text-zinc-400">Exam date {fmtDate(r.date)} · Generated by Schola-AI</div>
        </div>
      )}
    </div>
  );
}
